export const FETCH_CONTRACT_FAC_AMENDMENT_BEGIN = 'FETCH_CONTRACT_FAC_AMENDMENT_BEGIN';
export const FETCH_CONTRACT_FAC_AMENDMENT_SUCCESS = 'FETCH_CONTRACT_FAC_AMENDMENT_SUCCESS';
export const FETCH_CONTRACT_FAC_AMENDMENT_FAILURE = 'FETCH_CONTRACT_FAC_AMENDMENT_FAILURE';
export const FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_BEGIN = 'FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_BEGIN';
export const FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_SUCCESS = 'FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_SUCCESS';
export const FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_FAILURE = 'FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_FAILURE';
export const CHANGE_CONTRACT_FAC_AMENDMENT_NUM_VALUE = 'CHANGE_CONTRACT_FAC_AMENDMENT_NUM_VALUE';
export const FETCH_FAC_AMENDMENT_BEGIN = 'FETCH_FAC_AMENDMENT_BEGIN';
export const FETCH_FAC_AMENDMENT_SUCCESS = 'FETCH_FAC_AMENDMENT_SUCCESS';
export const FETCH_FAC_AMENDMENT_FAILURE = 'FETCH_FAC_AMENDMENT_FAILURE';
export const CHANGE_FAC_AMENDMENT_NUM_VALUE = 'CHANGE_FAC_AMENDMENT_NUM_VALUE';
export const FETCH_FAC_AMENDMENT_BY_DOSS_BEGIN = 'FETCH_FAC_AMENDMENT_BY_DOSS_BEGIN';
export const FETCH_FAC_AMENDMENT_BY_DOSS_SUCCESS = 'FETCH_FAC_AMENDMENT_BY_DOSS_SUCCESS';
export const FETCH_FAC_AMENDMENT_BY_DOSS_FAILURE = 'FETCH_FAC_AMENDMENT_BY_DOSS_FAILURE';
export const FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_BEGIN = 'FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_BEGIN';
export const FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_SUCCESS = 'FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_SUCCESS';
export const FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_FAILURE = 'FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_FAILURE';

export function fetchAllContractFacAmendment(ndossier) {
  return dispatch => {
    dispatch(fetchAllContractFacAmendmentBegin());
    return fetch("/api/facamendment/getAllContractFac")
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        const filteredData = json.filter(item => item.ndossier === ndossier);
        dispatch(fetchAllContractFacAmendmentSuccess(filteredData));
        return filteredData;
      })
      .catch(error => dispatch(fetchAllContractFacAmendmentFailure(error)));
  };
}
export function fetchContractFacAmendmentByDoss(ndossier) {
  return dispatch => {
    dispatch(fetchContractFacAmendmentByDossBegin());
    return fetch("/api/facamendment/getAllContractFac")
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        const filteredData = json.filter(item => item.ndossier === ndossier);
        dispatch(fetchContractFacAmendmentByDossSuccess(filteredData));
        return filteredData;
      })
      .catch(error => dispatch(fetchContractFacAmendmentByDossFailure(error)));
  };
}


// export function fetchAllContractFacAmendment() { 
//   return dispatch => {
//     dispatch(fetchAllContractFacAmendmentBegin());
//     return fetch("/api/facamendment/getAllContractFac")
//       .then(handleErrors)
//       .then(res => res.json())
//       .then(json => {
//         dispatch(fetchAllContractFacAmendmentSuccess(json));
//         return json;
//       })
//       .catch(error => dispatch(fetchAllContractFacAmendmentFailure(error)));
//   };
// }

export function fetchAllFacAmendment() {
  return dispatch => {
    dispatch(fetchAllFacAmendmentBegin());
    return fetch("/api/facamendment/getAllFac")
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(fetchAllFacAmendmentSuccess(json));
        return json;
      })
      .catch(error => dispatch(fetchAllFacAmendmentFailure(error)));
  };
}

export function fetchFacAmendmentByDossIndex(ndossier, contractFacAmendmentIndex) {
  return dispatch => {
    dispatch(fetchFacAmendmentByDossIndexBegin());
    return fetch("/api/facamendment/getAllFac")
    .then(handleErrors)
    .then(res => res.json())
    .then(json => {
        const filteredFacs = json.filter(fac => fac.ndossier == ndossier && fac.amendment_number == contractFacAmendmentIndex);
        dispatch(changeFacAmendmentNumber(filteredFacs.length));
        dispatch(fetchFacAmendmentByDossIndexSuccess(filteredFacs));
        return filteredFacs;
      })
      .catch(error => dispatch(fetchFacAmendmentByDossIndexFailure(error)));
  };
}

export function fetchFacAmendmentRecapByDossIndex(ndossier, contractFacAmendmentIndex) {
  return dispatch => {
    dispatch(fetchFacAmendmentRecapByDossIndexBegin());
    return fetch("/api/facamendment/getAllFacRecap")
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        const filteredFacs = json.filter(fac => fac.ndossier == ndossier && fac.amendment_number == contractFacAmendmentIndex);
        dispatch(fetchFacAmendmentRecapByDossIndexSuccess(filteredFacs));
        return filteredFacs;
      })
      .catch(error => dispatch(fetchFacAmendmentRecapByDossIndexFailure(error)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export const fetchAllContractFacAmendmentBegin = () => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_BEGIN
});

export const fetchAllContractFacAmendmentSuccess = contractFacAmendment => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_SUCCESS,
  payload: { items: contractFacAmendment, index: contractFacAmendment.length > 0 ? contractFacAmendment[0].amendment_number : 0 }
});

export const fetchAllContractFacAmendmentFailure = error => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_FAILURE,
  payload: { error }
});

export const fetchContractFacAmendmentByDossBegin = () => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_BEGIN
});

export const fetchContractFacAmendmentByDossSuccess = contractFacAmendment => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_SUCCESS,
  payload: { items: contractFacAmendment }
});

export const fetchContractFacAmendmentByDossFailure = error => ({
  type: FETCH_CONTRACT_FAC_AMENDMENT_BY_DOSS_FAILURE,
  payload: { error }
});

export const changeContractFacAmendmentNumber = (newValue) => ({
  type: CHANGE_CONTRACT_FAC_AMENDMENT_NUM_VALUE,
  payload: { newValue }
});

export const fetchAllFacAmendmentBegin = () => ({
  type: FETCH_FAC_AMENDMENT_BEGIN
});

export const fetchAllFacAmendmentSuccess = facAmendment => ({
  type: FETCH_FAC_AMENDMENT_SUCCESS,
  payload: { items: facAmendment }
});

export const fetchAllFacAmendmentFailure = error => ({
  type: FETCH_FAC_AMENDMENT_FAILURE,
  payload: { error }
});

export const changeFacAmendmentNumber = (newValue) => ({
  type: CHANGE_FAC_AMENDMENT_NUM_VALUE,
  payload: { newValue }
});

export const fetchFacAmendmentByDossIndexBegin = () => ({
  type: FETCH_FAC_AMENDMENT_BY_DOSS_BEGIN
});

export const fetchFacAmendmentByDossIndexSuccess = facAmendment => ({
  type: FETCH_FAC_AMENDMENT_BY_DOSS_SUCCESS,
  payload: { items: facAmendment }
});

export const fetchFacAmendmentByDossIndexFailure = error => ({
  type: FETCH_FAC_AMENDMENT_BY_DOSS_FAILURE,
  payload: { error }
});

export const fetchFacAmendmentRecapByDossIndexBegin = () => ({
  type: FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_BEGIN
});

export const fetchFacAmendmentRecapByDossIndexSuccess = facAmendment => ({
  type: FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_SUCCESS,
  payload: { items: facAmendment }
});

export const fetchFacAmendmentRecapByDossIndexFailure = error => ({
  type: FETCH_FAC_AMENDMENT_RECAP_BY_DOSS_FAILURE,
  payload: { error }
});